import { render, staticRenderFns } from "./RentPropertyShForm.vue?vue&type=template&id=532a5d47"
import script from "./RentPropertyShForm.vue?vue&type=script&lang=js"
export * from "./RentPropertyShForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports